import { injectIntl } from 'react-intl';
import ProfileDropdown from '~/components/GlobalHeader/Shared/components/ProfileDropdown';
import ProfileMenuOption from '~/components/GlobalHeader/Shared/components/ProfileMenuOption';
import { IntlType, UserInfo } from '~/components/GlobalHeader/Shared/type';
import { PROFILE_MENU_OPTIONS } from './config';
import useProfileData from './hooks/useProfileData';

const Profile = ({ intl }: { intl: IntlType }) => {
  const { user, actionConfig, isVisible, handleVisibilityChange } = useProfileData({ intl });

  return (
    <ProfileDropdown
      options={<ProfileMenuOption profileMenuOptions={PROFILE_MENU_OPTIONS(actionConfig)} />}
      user={{ name: user.name, email: user.email, image: user.pic } as UserInfo}
      intl={intl}
      isVisible={isVisible}
      handleVisibilityChange={handleVisibilityChange}
    />
  );
};
export default injectIntl(Profile);
